export default {
  graffito: [
    {
      id: 'localization',
      label: 'tabs#graffito_localization',
    },
    {
      id: 'date',
      label: 'tabs#graffito_date',
    },
    {
      id: 'description',
      label: 'tabs#graffito_description',
    },
    {
      id: 'text',
      label: 'tabs#graffito_text',
    },
    {
      id: 'conservation',
      label: 'tabs#graffito_conservation',
    },
    {
      id: 'biblio',
      label: 'tabs#graffito_biblio',
    },
    {
      id: 'observation',
      label: 'tabs#graffito_observation',
    },
    {
      id: 'links',
      label: 'tabs#graffito_links',
    },
  ],
};
